import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {UsuariosService} from '../usuarios/usuario.service';
import {Usuario} from '../usuarios/usuario';
import {Rol} from '../rol/rol';
import {RolService} from '../rol/rol.service';
import {LoginService} from '../login/login.service';
import {MiCuentaService} from "./miCuenta.service";

declare var $: any;

@Component({
    selector: 'miCuenta',
    template: require('../../app/miCuenta/miCuenta.component.html'),
    styles: [require('../../app/miCuenta/miCuenta.component.css')]
})

export class MiCuentaComponent implements OnInit {
    usuario: Usuario;
    roles: Rol[];
    active: any;
    deshabilitar: boolean;
    pruebaSMS: boolean;
    probando: boolean;
    tiposAlarmas: any;
    tiposAlarmasAdmin: any;
    medios: any;
    usuarioConectado: any;

    constructor(private router: Router,
                private usuarioService: UsuariosService,
                private rolService: RolService,
                private loginService: LoginService,
                private miCuentaService: MiCuentaService) {

    }

    ngOnInit() {
        this.tiposAlarmas = [{titulo: 'Notificaciones de sin actividad en los nodos:', value: 'sinactividad'},
            {titulo: 'Notificaciones de calibración:', value: 'calibracion'},
            {titulo: 'Notificaciones de valores anormales de alarmas para canales:', value: 'rango'}];
        this.tiposAlarmasAdmin = [
            {titulo: 'Notificaciones de bateria:', value: 'bateria'},
            {titulo: 'Notificaciones de sensor sin información:', value: 'sensornull'}];
        this.medios = ["SMS", "WhatsApp", "Email"]

        this.usuarioConectado = this.loginService.getDecodeToken();

        //Busco usuario
        this.usuarioService
            .getUsuario(this.loginService.getDecodeToken().id)
            .subscribe(user => {
                this.usuario = user;
                this.tiposAlarmasAdmin.forEach((tipo) => {
                    if (!this.usuario[tipo.value])
                        this.usuario[tipo.value] = {};
                })
                this.tiposAlarmas.forEach((tipo) => {
                    if (!this.usuario[tipo.value])
                        this.usuario[tipo.value] = {};
                })
            });

        //Inicializar banderas para resetear forms
        this.active = true;

        //Obtener roles
        this.rolService.getRoles()
            .subscribe(roles => {
                this.roles = roles;
            });

        //Seteo bandera para deshabilitar
        this.deshabilitar = false;
        this.pruebaSMS = false;
        this.probando = false;
    }

    guardarCambios() {
        this.deshabilitar = true;
        this.miCuentaService
            .save(this.usuario)
            .subscribe((usuario) => {
                this.usuario = usuario;
                this.deshabilitar = false;
            })
    }

    cancelar() {
        //Busco usuario
        this.deshabilitar = true;
        this.usuarioService
            .getUsuario(this.loginService.getDecodeToken().id)
            .subscribe(user => {
                this.usuario = user;
                this.deshabilitar = false;
                this.tiposAlarmasAdmin.forEach((tipo) => {
                    if (!this.usuario[tipo.value])
                        this.usuario[tipo.value] = {};
                })
                this.tiposAlarmas.forEach((tipo) => {
                    if (!this.usuario[tipo.value])
                        this.usuario[tipo.value] = {};
                })
            });
        let link = ['/home'];
        this.router.navigate(link);
    }

    probarCelular() {
        this.pruebaSMS = false;
        this.probando = true;
        if (this.usuario.celular != "") {
            console.log("OK");
            this.usuarioService.probarCelular(this.usuario.celular)
                .subscribe(
                    (result) => {
                        console.log("OK");
                        this.pruebaSMS = true;
                        this.probando = false;
                        $(document).on('hidden.bs.modal', '.modal', function () {
                            $('.modal:visible').length && $(document.body).addClass('modal-open');
                        });
                    },
                    (error) => {
                        this.probando = false;
                    }
                )

        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/miCuenta/miCuenta.component.ts